const { getAll } = require("@/utilities/querySelector");

const jobChoiceMakers = getAll('[data-vacancy-id]');
jobChoiceMakers.forEach(btn => btn.addEventListener('click', (e) => {
    const choice = e.currentTarget.getAttribute('data-vacancy-id');
    updateJobChoice(choice);
}));

function updateJobChoice(choice) {
    const selects = getAll(`select[data-job-select]`);
    selects.forEach(select => {
        const matchedOption = select.querySelector(`[data-vacancy-id="${choice}"]`);
        if (!matchedOption) return console.warn(`No option found with the value of ${choice}`);
        select.value = matchedOption.value;
        // Set the select field value to the vacancy title
        // select.querySelector('option[value="' + matchedOption.value + '"]').textContent = vacancyTitle;
    });
}


document.addEventListener("DOMContentLoaded", function () {
    const fileInputs = document.querySelectorAll(".file-input");

    fileInputs.forEach(input => {
        const fileInput = document.getElementById(input.getAttribute("for"));
        const initialText = input.textContent

        if (!fileInput) return;

        fileInput.addEventListener("change", function () {
            if (fileInput.files.length > 0) {
                input.textContent = fileInput.files[0].name;
            } else {
                input.textContent = initialText;
            }
        });
    })

});